import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import { PlansQueryResult, usePlansQuery } from "./use-plans.query";
const activePlanTierIds = ["SOLO", "GROWTH", "ENTERPRISE"] as const;
export function useActivePlans() {
  const $ = _c(4);
  const {
    data: plans
  } = usePlansQuery();
  let t0;
  if ($[0] !== plans) {
    t0 = plans?.filter(_temp);
    $[0] = plans;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const filteredPlans = t0;
  let t1;
  if ($[2] !== filteredPlans) {
    t1 = filteredPlans?.filter(_temp2);
    $[2] = filteredPlans;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function _temp2(plan_0) {
  return activePlanTierIds.includes(plan_0.tier.id as (typeof activePlanTierIds)[number]);
}
function _temp(plan) {
  return plan.isCurrent;
}